'use client';
import { RecipeMetaSectionProps } from '@repo/ui/src/types';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import { RecipeTimeProps } from '@views/RecipeDetailPage/_RecipeHero';

interface Props {
  recipeMetaSection: RecipeMetaSectionProps;
  _testID: string;
  prepTime: Array<RecipeTimeProps>;
  cookTime: Array<RecipeTimeProps>;
}

const RecipeCardInfo = ({ recipeMetaSection, _testID, prepTime, cookTime }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      data-test-id={`recipe_cook_data_${_testID}`}
      className="tw-border tw-border-warm-400 tw-rounded"
    >
      <div className="tw-grid tw-bg-white tw-justify-center tw-items-center tw-text-center tw-py-6 lg:tw-px-4 tw-rounded tw-px-4 tw-grid-cols-[repeat(auto-fit,minmax(0,1fr))] tw-gap-x-2">
        {!!prepTime?.length && (
          <div className="tw-flex tw-flex-col tw-items-center tw-border-r last:tw-border-r-0 tw-pr-2 last:tw-pr-0">
            <p className="tra-text-web-body-m tw-mb-0">{t('recipeContent.prepTimeLabel')}</p>
            <div className="tw-grid tw-grid-flow-col tw-gap-2">
              {prepTime?.map(({ label, value }, i) => (
                <h5 className="tra-text-web-heading-5" key={i}>
                  {value} {label}{' '}
                </h5>
              ))}
            </div>
          </div>
        )}

        {!!cookTime?.length && (
          <div className="tw-flex tw-flex-col tw-items-center tw-border-r last:tw-border-r-0 tw-pr-2 last:tw-pr-0">
            <p className="tra-text-web-body-m tw-mb-0">{t('recipeContent.cookTimeLabel')}</p>
            <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-justify-center">
              {cookTime?.map(({ label, value }, i) => (
                <h5 className="tra-text-web-heading-5" key={i}>
                  {value} {label}{' '}
                </h5>
              ))}
            </div>
          </div>
        )}

        {recipeMetaSection?.hardwood && (
          <div className="tw-flex tw-flex-col tw-items-center">
            <p className="tra-text-web-body-m tw-mb-0">{t('recipeContent.pelletsLabel')}</p>
            <h5 className="tra-text-web-heading-5">{recipeMetaSection?.hardwood}</h5>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeCardInfo;
